export default "__VITE_ASSET__784d054f__"